import { Facebook, Instagram, Linkedin, Mail, MapPin } from 'lucide-react'
import { Link } from 'react-router-dom'
import logoFarol from '@/assets/faroledu.jpg'

export function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300 py-12 border-t border-slate-800">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <img
                src={logoFarol}
                alt="Farol Edu"
                className="h-8 w-auto object-contain bg-white rounded-sm p-0.5"
              />
              <span className="font-bold text-xl text-white">Farol Edu</span>
            </div>
            <p className="text-slate-400 max-w-sm mb-6">
              A plataforma especializada em conectar escolas de educação básica
              aos melhores profissionais do mercado. Focada em agilidade e
              contexto escolar.
            </p>
            <div className="flex gap-4">
              <a href="#" className="hover:text-white transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="hover:text-white transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="#" className="hover:text-white transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contato</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <Mail className="w-4 h-4 mt-0.5 text-brand-emerald" />
                <span>contato@faroledu.com.br</span>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-0.5 text-brand-emerald" />
                <span>São Paulo, SP - Brasil</span>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-white font-semibold mb-4">Legal</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href="#"
                  className="hover:text-brand-emerald transition-colors"
                >
                  Termos de Uso
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="hover:text-brand-emerald transition-colors"
                >
                  Política de Privacidade
                </a>
              </li>
              <li>
                <Link
                  to="/anunciar-vaga"
                  className="hover:text-brand-emerald transition-colors"
                >
                  Para Escolas
                </Link>
              </li>
              <li>
                <Link
                  to="/cadastro-educador"
                  className="hover:text-brand-emerald transition-colors"
                >
                  Para Educadores
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-slate-500">
          <p>
            &copy; {new Date().getFullYear()} Farol Edu. Todos os direitos
            reservados.
          </p>
          <p className="mt-2 md:mt-0">Feito com 💚 para a educação.</p>
        </div>
      </div>
    </footer>
  )
}
